<template>
  <div class='core'>
    <div class='layui-fluid'>
      <el-table
        border
        :data="pagerData.data"
        style="width: 100%"
        class="table-statistics-style"
      >
        <el-table-column
          prop="num"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="client_name"
          label="品牌"
          width="150">
        </el-table-column>
        <el-table-column
          prop="store_name"
          label="门店名称"
          width="300">
        </el-table-column>
        <el-table-column
          prop="store_manager"
          label="店长"
          width="120">
        </el-table-column>
        <el-table-column
          prop="address"
          label="地址"
          width="450">
        </el-table-column>
        <el-table-column align="center" label="故障大类">
          <el-table-column
            prop="kitchen_equipment_num"
            label="厨具设备"
            width="120">
          </el-table-column>
          <el-table-column
            prop="hydroelectric_equipment_num"
            label="水电设备"
            width="120">
          </el-table-column>
          <el-table-column
            prop="airconditioning_equipment_num"
            label="空调设备"
            width="120">
          </el-table-column>
          <el-table-column
            prop="cooler_equipment_num"
            label="冷饮设备"
            width="120">
          </el-table-column>
          <el-table-column
            prop="it_equipment_num"
            label="IT设备"
            width="120">
          </el-table-column>
          <el-table-column
            prop="subtotal_num"
            label="小计"
            width="120">
          </el-table-column>
        </el-table-column>
        <el-table-column align="center" label="解决方式">
          <el-table-column
            prop="remote_num"
            label="远程"
            width="120">
          </el-table-column>
          <el-table-column
            prop="visit_num"
            label="上门"
            width="120">
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 20, 50]"
        :page-size="220"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagerData.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"
import request from "@/network/networkconfig";

export default {
  name: 'totalStatistics',
  props: {
    totalStatisticsList: {
      type: Array,
      default: ()=> {
        return [];
      }
    },
    rowCount: {
      type: Number,
      default: 0
    },
    endDate: {
      default: '',
      type: String
    },
    beginDate: {
      default: '',
      type: String
    },
    loading: {
      type: Boolean,
      default: ()=>{
        return true;
      }
    },
  },
  data () {
    return {
      pagerData: {
        data: [],
        total: 0
      },
      pageIndex: 0,
      pageSize: 10,
    }
  },
  watch:{
    totalStatisticsList(value) {
      this.pagerData.data = value
    },
    rowCount(value) {
      this.pagerData.total = value
    },
    loading(value) {
      this.loading = value
    },
  },
  mounted(){
    this.pagerData.data = this.totalStatisticsList
    this.pagerData.total = this.rowCount
  },
  methods: {
    handleSizeChange(val) {
      // 每次切换条数  页数变为第一页
      this.pageSize = val
      this.pageIndex = 0
      // 调用父组件查询
      this.$emit('queryRepairTotalStatisticsList',this.beginDate, this.endDate, this.pageIndex, this.pageSize)
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      // 调用父组件查询
      this.$emit('queryRepairTotalStatisticsList',this.beginDate, this.endDate, this.pageIndex, this.pageSize)

    }
  }
}
</script>

<style scoped>
.table-statistics-style {
  height: calc(100vh - 286px);
}
</style>





// WEBPACK FOOTER //
// src/components/repairs/repairStatistics/totalStatistics.vue